import { useTheme } from '@/contexts/ThemeContext';
import type { ReactNode } from 'react';

export interface LuxModalBodyProps {
  /** Contenu du body */
  children: ReactNode;
  /** Classes CSS additionnelles */
  className?: string;
  /** Style inline */
  style?: React.CSSProperties;
}

export function LuxModalBody({ children, className = '', style }: LuxModalBodyProps) {
  const { resolvedTheme } = useTheme();
  const textClass = resolvedTheme === 'dark' ? 'text-slate-300' : 'text-gray-700';

  return (
    <div className={`px-6 py-4 ${textClass} ${className}`} style={style} data-lux-modal-body>
      {children}
    </div>
  );
}
